import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { FileUploadModule } from "ng2-file-upload/ng2-file-upload";
import { Ng2CompleterModule } from "ng2-completer";
import { FormulariosComponent } from "./formularios.component";
import { FormulariosService } from "./formularios.service";
import { DataFilterNombreArchivo } from "./formularios.filter";
import { CabeceraModule } from "../../components/common/cabecera/cabecera.module";

@NgModule({
    declarations: [FormulariosComponent, DataFilterNombreArchivo],
    imports: [
        BrowserModule,
        Ng2CompleterModule,       
        HttpModule,
        FormsModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        FileUploadModule,
        Ng2Webstorage,
        CabeceraModule],
    providers: [FormulariosService]
})

export class FormulariosModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/formularios/formularios.module.ts